import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m12.865 11.366 1.91 1.134H16v-9h-1.225l-1.91 1.134a5.7 5.7 0 0 0-.39-1.396C11.756 1.611 10.238 1 7.525 1H5.474C1.368 1 0 2.4 0 6.6v2.8C0 13.6 1.368 15 5.474 15h2.052c2.713 0 4.231-.611 4.948-2.238q.265-.601.391-1.396m1.735-.598L11.81 9.11l-.327 2.033c-.178 1.105-.53 1.596-.958 1.882-.506.338-1.388.575-2.999.575H5.474c-1.97 0-2.835-.353-3.275-.804-.45-.46-.799-1.368-.799-3.396V6.6c0-2.028.35-2.937.799-3.396.44-.45 1.305-.804 3.275-.804h2.052c1.61 0 2.493.237 2.999.575.428.286.78.777.958 1.882l.327 2.033 2.79-1.658z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VideocameraOutlinedSize16Glyph.displayName = 'VideocameraOutlinedSize16Glyph';
